<mapfre-card additionalClasses="error-page maintence" [additionalSectionClasses]="'error-section'">
  <div class="row padding-top pt36 margin-bottom mb8">
    <div class="col">
        <img [src]="image" alt="" class="logo" />
      </div>
  </div>
  <div class="row">
    <div class="col">
      <h1 class="title-copy text-center">{{ errorType | translate }}</h1>
    </div>
  </div>
  <div class="row text-center">
    <div class="col">
      <p class="color-class">{{ copy | translate }}</p>
    </div>
  </div>
  <div class="row margin-bottom mb24">
    <div class="col">
        <a routerLink="/login"  class="btn mapfre waves-light basic primary large"> {{'HOME' | translate}} </a> 
    </div>
  </div>
  <div class="row text-center">
    <div class="col">
      <ng-container *ngIf="!isAcmic else acmic;">
      <a href="https://www.mapfreinsurance.com/en/contact/">
        <mapfre-button 
          additionalClasses="waves-light ghost secondary large h40"> {{'CONTACT_US' | translate}} </mapfre-button>
      </a>
    </ng-container>
    <ng-template #acmic>
      <a class="underline mapfre link red-link" href="tel:18442954500">
        {{ "CALL_US_NUMBER" | translate}}
      </a>
    </ng-template>
    </div>
  </div>
</mapfre-card>
